<div class="tp-page tp-page--compact level-benefits-container">
  <section class="tp-card tp-card--flush">
    <tp-page-header variant="toolbar" title="Beneficios por nivel"
    [subtitle]="grouped.length + (grouped.length === 1 ? ' beneficio' : ' beneficios')">
    <button mat-flat-button actions id="addButton" type="button" (click)="openModal()">
      <mat-icon>add</mat-icon>
      Agregar beneficio
    </button>
    </tp-page-header>
    <ul class="sa-list">
      @for (item of grouped; track item) {
        <li class="sa-item">
          <div class="sa-item__body">
            <p class="sa-item__title">{{ item.levelName }}</p>
            <p class="sa-item__meta benefit-description">
              <span>{{ item.benefitDescription }}</span>
            </p>
          </div>
          <app-icon-menu-button [menu]="menu" label="Más opciones"></app-icon-menu-button>
          <mat-menu #menu="matMenu">
            <button id="editButton" mat-menu-item (click)="openModal(item)">Editar</button>
            <button id="deleteButton" mat-menu-item
              (click)="deleteLevelBenefit(item.benefitId,item.levelName)">Eliminar</button>
          </mat-menu>
        </li>
      } @empty {
        <li>
          <tp-empty-state
            icon="redeem"
            title="Todavía no hay beneficios"
            message="Agregá el primer beneficio con el botón de arriba."
          ></tp-empty-state>
        </li>
      }
    </ul>
  </section>

  <!-- Panel de alta / edición de beneficio -->
  <div class="level-modal-container d-flex align-items-center justify-content-center w-100"
    [ngClass]="{ expanded: showBenefitModal }">
    @if (showBenefitModal) {
      <div class="modal-container w-100">
        <app-level-benefits-modal [levels]="levels" [selectedBenefit]="selectedBenefitToEdit"
        (closeModal)="backToBenefits()" (reloadPage)="getlevels()"></app-level-benefits-modal>
      </div>
    }
  </div>
</div>
